import { DATETIME_OPTIONS, DATE_OPTIONS } from '@/utils/const';

const filters = {
  firstLetter(value: string) {
    return value != null ? value[0] : '';
  },

  capitalize(value: string) {
    return value != null ? value.charAt(0).toUpperCase() + value.slice(1) : '';
  },

  uppercase(value: string) {
    return value != null ? value.toString().toUpperCase() : '';
  },

  getDateOnly(value: string) {
    return value != null
      ? new Date(value).toLocaleDateString('en-US', DATE_OPTIONS)
      : '-';
  },

  getTimeOnly(value: string) {
    return value != null
      ? new Date(value).toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
        })
      : '-';
  },

  getTimeOnly24Hrs(value: string) {
    return value != null
      ? new Date(value).toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        })
      : '-';
  },

  getDateAndTime(value: string) {
    return value != null
      ? new Date(value).toLocaleDateString('en-US', DATETIME_OPTIONS)
      : '-';
  },

  checkDateRange(startDate: Date, endDate: Date): number {
    const now = new Date();
    if (now > endDate) {
      return 0; // Past
    } else if (now > startDate && now < endDate) {
      return 1; // Within the range
    } else if (now < startDate) {
      return 0;
    } else {
      return 0;
    }
  },

  formatDate(value: string) {
    return new Date(value).toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  },

  formatPrice(value: number, currencyISO3: string | null) {
    let currencyObj: Intl.NumberFormatOptions = {
      style: 'currency',
      ...(currencyISO3 != null ? { currency: currencyISO3 } : {}),
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };

    const formatter = new Intl.NumberFormat('en-US', currencyObj);
    return value != null ? formatter.format(value) : '-';
  },

  round(value: number) {
    return value.toFixed(2);
  },

  capitalizedFirstLetter(str: string) {
    if (!str) return '';
    return str.charAt(0).toUpperCase();
  },

  formatNumberWithComma(number: number) {
    if (isNaN(number)) {
      return 'Invalid number';
    }
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  },
};

export default filters;
